<template>
  <div>
    <v-dialog
      ref="timeDialog"
      v-model="modal"
      :return-value.sync="internalTime"
      persistent
      lazy
      full-width
      width="290px"
    >
      <v-text-field
        slot="activator"
        v-model="dateFormatted"
        :label="name"
        prepend-icon="event"
        readonly
      ></v-text-field>
      <v-time-picker
        v-if="modal"
        v-model="internalTime"
        full-width
        format="24hr"
      >
        <v-spacer></v-spacer>
        <v-btn
          flat
          color="primary"
          @click="modal = false"
        >{{ $vuetify.t('$vuetify.lobis.cancel') }}</v-btn>
        <v-btn
          flat
          color="primary"
          @click="$refs.timeDialog.save(internalTime)"
        >{{ $vuetify.t('$vuetify.lobis.ok') }}</v-btn>
      </v-time-picker>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    time: String,
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      modal: false
    }
  },
  created () {
    if (!this.time) {
      this.internalTime = '01:00'
    }
  },
  computed: {
    dateFormatted () {
      return this.$moment.utc(this.$moment.duration(this.internalTime, 'H:m').as('milliseconds')).format('HH:mm')
    },
    internalTime: {
      get () {
        return this.time
      },
      set (value) {
        this.$emit('update:time', value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Formcomponents/Timepicker.vue